<template>
    <div class="mb-2 col-md-6" v-if="isVisible">
        <el-select
            :multiple="multiple"
            :clearable="clearable"
            :value="pending"
            @change="onChange"
            class="w-100"
            :placeholder="placeholder"
            filterable
            remote
            :remote-method="searchOptions"
        >
            <el-option
                v-for="option in options"
                :key="option[optionKey]"
                :label="option[optionLabel]"
                :value="option[optionValue]">
            </el-option>
        </el-select>
    </div>
</template>

<script>
  import BaseSelectFilter from "./base-select-filter";

  export default {
    extends: BaseSelectFilter,

    data() {
      return {
        options: _.get(this.data, 'initialOptions', []),
      };
    },

    computed: {
      /**
       * @return {string|null}
       */
      url() {
        return _.get(this.data, 'url', null);
      },
    },

    methods: {
      /**
       * @param {string} search
       */
      searchOptions(search) {
        axios.get(this.url, {params: {search}})
          .then(({data: {data = []}}) => this.options = data)
          .catch(err => {
            this.$message.error('Whoops. It looks like the server is unavailable.');
          });
      },
    },
  }
</script>
